import React from 'react';
import "./BottomFooter.css";
import { FaArrowUp } from 'react-icons/fa';

import { Link } from 'react-router-dom';

const BottomFooter = () => {

    const scrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <div className='b-footer-container'>
            <div className="footer-bottom">
                <div className="bottom-content">
                    <p>Copyright © 2026 Iconic Greenland. All Rights Reserved.</p>
                    <div className="bottom-links">

                        {/* <Link to="/privacy-policy" className="footer-link-item">Privacy Policy</Link> */}
                        {/* <link rel="stylesheet" href="/privacy-policy" >Privacy Policy</link> */}
                        <span>Privacy Policy</span>
                        <span>Terms & conditions</span>
                        <span>Sitemap</span>
                    </div>
                </div>

                <a href="#top" className="scroll-top" onClick={scrollToTop}>
                    <FaArrowUp />
                </a>
            </div>
        </div>
    );
};

export default BottomFooter;